import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LoginFormTypes } from "models/formTypes";
import { InputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { EmailInput, PasswordInput, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
//#endregion

const UserNameLoginForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const { wintFormProps, connect } = useWintForm<LoginFormTypes.UserNameLogin>({
    formRef: ref,
    ...props,
    validateOnBlur: true,
    validateOnChange: false,
    validateOnMount: false,
  });
  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<InputProps>
        Component={EmailInput}
        {...connect("userName")}
        label={TranslationKeys.Login.UserName}
        icon={IconDefinitionConstants.WUser}
      />
      <VerticalFormField<InputProps>
        Component={PasswordInput}
        {...connect("password")}
        label={TranslationKeys.Login.Password}
        icon={IconDefinitionConstants.WLock}
      />
    </WintForm>
  );
};

export default forwardRef(UserNameLoginForm);
